import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, FormNoData, ICustomTable } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { FormularioService } from '../../../../services/database/formulario.service';

@Component({
  selector: 'app-formularios-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle],
  templateUrl: './formularios-historico.component.html',
  styleUrl: './formularios-historico.component.scss'
})
export class FormulariosHistoricoComponent implements OnInit {
  title: string = 'Formulario Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private _fs: FormularioService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      formularios: this._t.get('common.formularios'),
      nombre: this._t.get('common.nombre'),
      descripcion: this._t.get('common.descripcion'),
      fechaCreacion: this._t.get('common.fechaCreacion'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      version: this._t.get('common.version'),
      categoria: this._t.get('common.categoria')
    }));
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'categoria',
          header: this.trans.categoria,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          class: 'brand-table-tag mx-auto my-auto font-13',
          dataType: DataColumnType.CUSTOM,
          sort: true,
          columnFilter: true
        },
        {
          field: 'nombre',
          header: this.trans.nombre,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'version',
          header: this.trans.version,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'fechaCreacion',
          header: this.trans.fechaCreacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          width: '13rem',
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '13rem',
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'edit',
          header: '',
          icon: 'pi pi-search',
          class: 'button-edit p-button-outlined pt-2 pb-2 pl-1 pr-1',
          width: '0rem',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: FormNoData) => this.onClick(data)
        },
      ]
    } as ICustomTable;

  }

  show(formularioId: number) {
    this.displayModal = true;
    this.loadHistorial(formularioId);
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(formularioId: number) {
    this._fs.getFormularioHistorico(formularioId).subscribe({
      next: (data: FormNoData[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._fs.getFormularioHistoricoEliminado().subscribe({
      next: (data: FormNoData[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  private onClick(data: FormNoData) {
    const url = `#/configuracion/formulario/edit/${data.id}/${data.version}`;
    window.open(url, '_blank');
  }
}
